/**
 * Retrieves data from localstorage and formats it
 * in the desired structure to be used for
 * SaveCSV, SubmitCSV and DownloadCSV
 * <input - "UpdatedDataArray", "companyNameEditable" and "companyName">
 * <output - csvData and updatedRow>
 */

// Retrieve Data from localStorage (CSV->JSON)
export const retrieveData = async () => {
  const savedFormattedDataArray = await JSON.parse(
    localStorage.getItem("UpdatedDataArray")
  );

  try {
    if (savedFormattedDataArray) {
      // Filter out empty rows
      const nonEmptyCSVData = savedFormattedDataArray.filter((row) => {
        // Assuming that a row is empty if it doesn't have any non-empty columns
        return Object.values(row).some((cell) => cell !== "");
      });
      return nonEmptyCSVData;
    }
  } catch (error) {
    throw new Error("Data array is not valid.");
  }
};

//Adjust the DateTime (per value entry) to the format dd-MM-yyyyThh:mm:ss
const getCurrentFormattedDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${day}-${month}-${year}T${hours}:${minutes}:${seconds}`;
};

export const formatCSVData = (data) => {
  // Get attributes from local storage
  const CompanyNameEditable = localStorage.getItem("companyNameEditable");
  const companyName = localStorage.getItem("companyName");
  const snapshotName = localStorage.getItem("selectedSnapshot");
  const isRepXFile = snapshotName.toLowerCase().includes("repx");
  const dataLoc = process.env.REACT_APP_REPX_DATALOC;
  const repxOutput = process.env.REACT_APP_S3_REPX_OUTPUT;

  if (CompanyNameEditable === null || companyName === null || snapshotName === null) {
    throw new Error("Required data missing in local storage.");
  }

  if (data) {
    return (
      data
        // Map over each row in the data array and updating each row
        .map((row, rowIndex) => {
          const updatedRow = {
            // Only show these values on the first row
            CompanyNameEditable: rowIndex === 0 ? CompanyNameEditable : "",
            "Company Name": rowIndex === 0 ? companyName : "",
            ...row, // Adding the rest of the data array
            "DateTime (per value entry)": getCurrentFormattedDate(),
          };

          // If it's a RepX file, ensure specific properties are set
          if (isRepXFile) {
            if (row.Property === "snapshot_location") {
              updatedRow["Value (per property)"] = `${repxOutput}/${snapshotName}`;
            } else if (row.Property === "snapshot_name") {
              updatedRow["Value (per property)"] = `${snapshotName}.csv`;
            } else if (row.Property === "data_loc") {
              updatedRow["Value (per property)"] = dataLoc;
            }
          }

          return updatedRow;
        })
    );
  } else {
    return [];
  }
};
